import { openLogin } from "../auth";

export function Login() {
  return (
    <div className="login">
      <section className="login-side">
        <div className="login-card">
          <img src="/vetproof-logo.png" alt="Vetproof — one scan, full story" />
          <h2>Sign in</h2>
          <p>Clinic staff see every patient on the network and can add sealed records. Pet owners see their own pets' records.</p>
          <button className="btn teal" onClick={() => openLogin("login")}>Sign in</button>
          <button className="btn ghost" onClick={() => openLogin("signup")}>Create an account</button>
          <div className="fine">Secured by Netlify Identity. Access to the record is granted per role by your clinic administrator.</div>
        </div>
      </section>
    </div>
  );
}
